const messages = {
  title: "Početna",
  welcomeMessage:
    'Dobrodošli u BRIDGESTONE <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  home: "Početna",
  search: "Pretražite",
  sortBy: "Sortirajte po",
  seeMore: "Pogledajte više",
  bankstatement: {
    yourScore: "Vaš trenutni broj marketinških poena:",
    lastUpdate: "Poslednje ažuriranje:",
    link: "Pregled stanja poena",
  },
  shop: {
    bestSold: "Najprodavanije",
    seasonal: "Sezonsko",
    affordable: "Pristupačno",
    forPoints: "za {points} poena",
    reachedPoints: "Potrebni poeni dostignuti",
    cartRemainPoints: "Preostali poeni",
    remainingPoints: "{points} Preostalih poena",
    noProducts: "Kriterijumi pretrage nisu dali rezultate",
    variant: "Varijante na izbor",
  },
  showAllProducts: "Idite u šop",
  shopClosedBanner:
    "<div>BRIDGESTONE <span class='text-danger'>PLUS</span> SHOP</div><div>uskoro će ponovo biti dostupan.</div>",
};
export default {
  messages,
};
